import { bootboxConfirm } from "../../backend/before";

const AddressListPage = () => {
    const main = document.getElementById('address-list');
    if (!main) {
        return;
    }

    const element = {
        formDelete: $('#form-delete'),
        btnAddressDelete: '.btn-address-delete',
    };

    $(element.btnAddressDelete).click(function (e) {
        e.preventDefault();
        const id = $(this).data('id');

        bootboxConfirm('Delete Address', 'you really want to delete this address', function () {
            element.formDelete.attr('action', `/user/addresses/${id}/delete`)
                .trigger('submit');
        });
    })
};

$(() => {
    AddressListPage();
});

